class TierFilter extends HTMLElement {
  constructor() {
    super();
    this.defaultParamName = this.dataset.param;
    this.buttons = [];
    this.onOptionClick = this.onOptionClick.bind(this);
    this.onPopState = this.onPopState.bind(this);
  }

  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('.tier-filter__option'));
    this.buttons.forEach((btn) => btn.addEventListener('click', this.onOptionClick));
    window.addEventListener('popstate', this.onPopState);
    this.syncFromUrl();
  }

  disconnectedCallback() {
    this.buttons.forEach((btn) => btn.removeEventListener('click', this.onOptionClick));
    window.removeEventListener('popstate', this.onPopState);
  }

  normalizeToRaw(value) {
    if (value == null) return null;
    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  }

  getCurrentRawValue(paramName) {
    const url = new URL(window.location.href);
    const val = url.searchParams.get(paramName);
    return this.normalizeToRaw(val);
  }

  setSelectedState(paramName, selectedRawVal) {
    this.buttons.forEach((btn) => {
      const isClear = btn.hasAttribute('data-clear');
      const btnParam = btn.dataset.param || this.defaultParamName;
      const btnRawVal = this.normalizeToRaw(btn.dataset.value);

      const isActive = isClear
        ? !selectedRawVal && btnParam === paramName
        : btnParam === paramName && selectedRawVal && btnRawVal === selectedRawVal;

      btn.classList.toggle('is-active', !!isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  syncFromUrl() {
    const paramName = this.defaultParamName;
    const selectedRawVal = this.getCurrentRawValue(paramName);
    this.setSelectedState(paramName, selectedRawVal);
  }

  onPopState() {
    this.syncFromUrl();
  }

  onOptionClick(event) {
    event.preventDefault();
    const btn = event.currentTarget;

    const paramName = btn.dataset.param || this.defaultParamName;
    const btnRawVal = this.normalizeToRaw(btn.dataset.value);

    const url = new URL(window.location.href);
    const currentRawVal = this.getCurrentRawValue(paramName);

    if (btn.hasAttribute('data-clear')) {
      url.searchParams.delete(paramName);
      url.searchParams.delete('page');
      return this.navigate(url);
    }

    if (currentRawVal && btnRawVal && currentRawVal === btnRawVal) {
      url.searchParams.delete(paramName);
    } else {
      url.searchParams.set(paramName, btnRawVal);
    }

    url.searchParams.delete('page');
    this.navigate(url);
  }

  navigate(url) {
    window.location.assign(url.toString());
  }
}

customElements.define('tier-filter', TierFilter);
